<template>
  <div>
    <template v-if="!account1 && needConnect">
      <el-button class="common-btn-blue" @click="connectWallet" :loading="loading">
        Connect Wallet
      </el-button>
    </template>
    <template v-else>
      <el-button
        :loading="loading"
        class="common-btn-blue"
        @click="clickHandle"
        :disabled="disabled"
      >
        {{ label }}
      </el-button>
    </template>
  </div>
</template>

<script>
import { getToken, setToken, removeToken, setRefreshToken } from "@/utils/auth";

export default {
  props: {
    label: {
      type: String,
      default: () => {
        return "Submit";
      }
    },
    disabled: {
      type: Boolean
    },
    needConnect: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    account1() {
      return this.$store.getters.metaMaskObj.account;
    }
  },
  watch: {
    account1: {
      handler(newValue, oldValue) {
        // console.log(newValue);
        this.account = newValue;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    clickHandle() {
      this.loading = true;
      this.$emit("clickHandle", this);
    },
    closeLoad() {
      this.loading = false;
    },
    async connectWallet() {
      try {
        this.loading = true;
        // Will open the MetaMask UI
        await ethereum.request({ method: "eth_requestAccounts" });
        const accounts = await ethereum.request({ method: "eth_accounts" });
        if (!accounts[0]) {
          this.$message.error("Not able to get accounts");
          this.loading = false;
          return;
        } 
        
        this.account = accounts[0];
        this.$store.commit("app/SET_MATEMASK", {
          isConnect: true,
          account: accounts[0]
        });
        setToken(this.account);
        
        // 发送初始化事件，让父组件知道钱包已连接
        this.$emit("walletConnected", accounts[0]);
        this.loading = false;
      } catch (error) {
        console.error("Failed to connect wallet:", error);
        this.loading = false;
        this.$store.commit("app/SET_MATEMASK", { isConnect: false });
        this.$message.error("Failed to connect wallet");
      }
    }
  },
  mounted() {
    console.log('needConnect', this.needConnect);
    console.log('account1', this.account1);
  }
};
</script>
<style scoped lang="scss">
.common-btn-blue {
  font-family: DMSans-Medium;
  border-radius: 0.14rem;
}
</style>
